<div *checkPermission="{ role: 'editor'}" ngbTooltip="{{'buttons.errorJsonRetry' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"
    triggers="hover" (click)="clickBtnOpenModal(content, $event)" class="btn-bluerotate">
    <div class="btn-icon" aria-label="details" [inlineSVG]="'assets/ico/rotate-solid.svg'"></div>
</div>



<ng-template #content let-modal>
    <div class="modal-header light-blue">
        <div class="container-fluid">
            <div class="row modal-header-row">
                <div class="modal-icon icon fill-white" aria-label="logo"
                    [inlineSVG]="'assets/ico/exclamation-triangle-regular-white.svg'">
                </div>
                <span class="modal-title" id="modal-basic-title">
                    {{'order.errors.retry' | translate}}
                </span>
                <div class="modal-icon icon fill-white close-icon" (click)="clickBtnClose()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="fullwidth">
            <div class="container-fluid">
                <div class="d-flex justify-content-between">
                    <div class="mb-1">{{'order.errors.updated' | translate}}: {{updated}}</div>

                    <span class="btn-format" (click)="clickBtnFormatJSON()">Formatta JSON</span>
                </div>
                <form [formGroup]="form" class="d-flex justify-content-center">
                    <div class="row pos-relative">
                        <div class="copy-button" (click)="clickBtnCopyText()" >
                            <div class="btn-icon mr-1" aria-label="details" [inlineSVG]="'assets/ico/copy-solid-full.svg'">
                            </div>
                            {{messagecopy}}
                        </div>

                        <textarea #textArea class="textarea-custom" spellcheck="false" cols=138 rows=20
                            formControlName="jsonParsedForm" [value]="jsonParsedForm">
                    </textarea>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <button class="btn modal-btn save mr-3 ml-1 " (click)="clickBtnSave()" 
            [disabled]="(form.status === 'INVALID' && form.touched === true)">
                Save
            </button>
            <button class="btn modal-btn reset mx-1" (click)="clickBtnReset()">Reset</button>
        </div>
    </div>
</ng-template>